import { createPinMarker, getScaledFontSize, getTextFormat, } from 'app/core/markers/models';
import { ProjectActions } from 'app/stores/project/actions';
import { getInsertStyle, getMaximumPinNumber } from 'app/stores/selectors';
import { measureText } from 'app/utils/text';
export const InsertPin = () => (dispatch, getState) => {
    const state = getState();
    const { size, color, sizeFactor } = getInsertStyle(state);
    const onDragStart = (payload, point) => {
        const fontSize = getScaledFontSize(size, sizeFactor);
        const format = getTextFormat(fontSize);
        const number = getMaximumPinNumber(getState()) + 1;
        const { lines: [line], width, } = measureText(String(8), format);
        const { lines, width: innerWidth, height: innerHeight, } = measureText(String(number), format);
        const marker = createPinMarker({
            x: point.x,
            y: point.y,
            width,
            height: line.ascent * 0.85,
            descent: lines[0].descent,
            innerWidth,
            innerHeight,
            format,
            size,
            color,
            number,
        });
        payload.itemId = marker.id;
        dispatch(ProjectActions.itemInsert({
            marker,
            undoable: true,
        }));
    };
    const onDrag = (payload, point) => {
        const { itemId: id } = payload;
        if (id) {
            dispatch(ProjectActions.itemUpdate({
                id,
                patch: {
                    x: point.x,
                    y: point.y,
                },
                undoable: false,
            }));
        }
    };
    const onDragEnd = (_payload, _point) => {
        /* noop */
    };
    return {
        onPointerDown: onDragStart,
        onPointerDrag: onDrag,
        onPointerUp: onDragEnd,
    };
};
